export enum StatusCode {
    OK = 200,
    NoContent = 204,
    RequestMalformed = 400,
    RequestUnauthorized = 401,
    RequestForbidden = 403,
    RequestNotFound = 404,
    InternalServerError = 500,
}
